"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Consumer = exports.Provider = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const context = react_1.default.createContext({
    currentModalZIndex: 100,
    setCurrentModalZIndex: () => { },
});
exports.Provider = context.Provider, exports.Consumer = context.Consumer;
exports.default = context;
